module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-operatorchat-7dae3e082464fa335181887e2c876edf.gif";